import secureStorage from "../../../services/secureStorage";
import {
  SS_AUTH_TOKEN,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../utility/constants/secureStorageManager";
import {
  ACTIVE,
  ADMIN,
  ADMIN_USER,
  APPROVED,
  CLIENT,
  FINANCE,
  OPERATIONS,
  PENDING,
  RESELLER,
  RNC,
  RNCPENDING,
  SALES,
  SUPPORT
} from "../../../utility/constants/valueConstants";
import {
  ApiPostServiceWithoutAuthenticationWrapper,
  ApiPostServiceWrapper,
  ApiPostServiceWrapperWithFormData,
  ApiPutServiceWrapper
} from "../wrapperService";
import { API_ENDPOINT } from "./ApiEndpoint";

export const ApiRequestPost = {
  login: ({ email, password }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { email, password },
        headers: {},
        url: API_ENDPOINT.user_service_url + "login/otp/send"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loginWithoutOtp: ({ email, password }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { email, password },
        headers: {},
        url: API_ENDPOINT.user_service_url + "login/single-signin"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  verifyOtp: ({ email, otpRefCode, otp }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { email, otpRefCode, otp },
        headers: {},
        url: API_ENDPOINT.user_service_url + "login/otp/verify"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setup2fa: ({ userId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: {
          userId
        },
        headers: {},
        url: API_ENDPOINT.user_service_url + "login/mfa/setup"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  verify2fa: ({ userId, code }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: {
          userId,
          code
        },
        headers: {},
        url: API_ENDPOINT.user_service_url + "login/mfa/verify"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  forgotPasswordSendOtp: ({ email }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { email },
        headers: {},
        url: API_ENDPOINT.user_service_url + "forgot-password/otp/send"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setPassword: ({ userID, password }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { userID, password },
        headers: {},
        url: API_ENDPOINT.user_service_url + "set-password"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  forgotPasswordVerifyOtp: ({ email, otpRefCode, otp }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { email, otpRefCode, otp },
        headers: {},
        url: API_ENDPOINT.user_service_url + "forgot-password/otp/verify"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  forgotPasswordChange: ({
    userId,
    newPassword,
    confirmPassword,
    otpRefCode
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWithoutAuthenticationWrapper({
        body: { userId, newPassword, confirmPassword, otpRefCode },
        headers: {},
        url: API_ENDPOINT.user_service_url + "forgot-password/change"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUserDetails: ({ role, userId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { role, userId },
        // headers: {
        //   Authorization: "Bearer " + token
        // },
        url: API_ENDPOINT.core_url + "user/fetch/details"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  adminApproveRejectAction: ({
    clientId,
    status,
    reason = "",
    isCancelled = ""
  }) => {
    return new Promise((resolve, reject) => {
      const fname = secureStorage.getItem(SS_FIRST_NAME);
      const lname = secureStorage.getItem(SS_LAST_NAME);
      const email = secureStorage.getItem(SS_EMAIL);
      const userId = secureStorage.getItem(SS_USER_HASH_ID);

      ApiPostServiceWrapper({
        body: {
          clientId,
          status,
          reason,
          email: email,
          userId: userId,
          userName: fname + " " + lname,
          isCancelled
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/onboard/approove/action"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  approveRejectActionStatus: ({
    clientId,
    reason = "",
    status,
    service,
    deactivateSubCore
  }) => {
    return new Promise((resolve, reject) => {
      const fname = secureStorage.getItem(SS_FIRST_NAME);
      const lname = secureStorage.getItem(SS_LAST_NAME);
      const email = secureStorage.getItem(SS_EMAIL);
      const userId = secureStorage.getItem(SS_USER_HASH_ID);
      ApiPostServiceWrapper({
        body: {
          clientId,
          reason,
          email: email,
          userId: userId,
          userName: fname + " " + lname,
          status,
          service,
          deactivateSubCore: deactivateSubCore
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/onboard/approove/actions"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllVanCustomerList: ({
    page = 1,
    size = 10,
    dateRange = "",
    customerHashId,
    keyWord = "",
    van = "",
    name = "",
    status,
    clientHashId = "",
    programId = "",
    serviceType
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        headers: {
          program_id: programId,
          client_id: role === CLIENT ? ss_id : ""
        },
        body: {
          page,
          size,
          dateRange,
          customerHashId,
          keyWord,
          van,
          name,
          status,
          clientHashId,
          programId,
          serviceType
        },
        url: API_ENDPOINT.core_url + "client/equitas/client/customer/list"
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllVanTransactionList: ({
    page = 1,
    size = 10,
    dateRange = "",
    keyWord = "",
    van = "",
    name = "",
    status,
    business = "",
    clientHashId = "",
    txnId = "",
    transferType = "",
    utr = "",
    programId = "",
    serviceType = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        headers: {
          program_id: programId,
          client_id: role === CLIENT ? ss_id : ""
        },
        body: {
          page,
          size,
          dateRange,
          business,
          keyWord,
          van,
          name,
          status,
          clientHashId,
          txnId,
          transferType,
          utr,
          serviceType
        },
        url: API_ENDPOINT.core_url + "client/transaction/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  clientAdd: ({ data }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: data,
        headers: {},
        url: API_ENDPOINT.core_url + "client/create"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addChargeBack: (data) => {
    console.log(data, "req--------data");

    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);

    return new Promise((resolve, reject) => {
      // Assuming the role validation is necessary, you can do it here or remove it if not needed
      ApiPostServiceWrapper({
        body: data, // Send the array of transactions as the request body
        headers: {},
        url: API_ENDPOINT.core_url + "client/add/chargeback"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchClientList: ({
    page = 0,
    size = 10,
    dateRange = "",
    onBoardedStatus = APPROVED,
    activeStatus = ACTIVE,
    userId,
    serviceType = "",
    userRefId = "",
    serviceProviderName = "",
    rootReferenceId = "",
    deactivatedList,
    businessName = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);

      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          userId: userId
            ? userId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === FINANCE ||
              role === RNC
            ? ""
            : userId,
          onBoardedStatus,
          activeStatus: activeStatus,
          userRefId: userRefId
            ? userRefId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === RNC ||
              role === FINANCE
            ? ""
            : role === RESELLER
            ? ss_id
            : "",
          serviceType,
          serviceProviderName,
          rootReferenceId: rootReferenceId
            ? rootReferenceId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === RNC ||
              role === FINANCE
            ? ""
            : role !== RESELLER
            ? ss_id
            : "",
          deactivatedList,
          businessName
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/fetch/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchClientListPending: ({
    page = 0,
    size = 10,
    dateRange = "",
    onBoardedStatus = RNCPENDING,
    activeStatus = PENDING,
    userId,
    serviceType = "",
    userRefId = "",
    serviceProviderName = "",
    rootReferenceId = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);

      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          userId,
          onBoardedStatus,
          activeStatus: activeStatus,
          userRefId: userRefId
            ? userRefId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT
            ? ""
            : role === RESELLER
            ? ss_id
            : "",
          serviceType,
          serviceProviderName,
          rootReferenceId: rootReferenceId
            ? rootReferenceId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === SALES
            ? ""
            : role !== RESELLER
            ? ss_id
            : ""
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/fetch/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchClientCount: ({
    userId,
    serviceType = "",
    userRefId = "",
    serviceProviderName = "",
    rootReferenceId = "",
    onBoardedStatus = APPROVED
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);

      ApiPostServiceWrapper({
        body: {
          userId,
          userRefId: userRefId
            ? userRefId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT
            ? ""
            : role === RESELLER
            ? ss_id
            : "",
          serviceType,
          serviceProviderName,
          rootReferenceId: rootReferenceId
            ? rootReferenceId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT
            ? ""
            : role !== RESELLER
            ? ss_id
            : "",
          onBoardedStatus
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/fetch/count"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchResellerList: ({
    page = 0,
    size = 10,
    dateRange = "",
    userId = "",
    status = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          userRefId:
            role === ADMIN ||
            role === ADMIN_USER ||
            role === OPERATIONS ||
            role === SUPPORT ||
            role === RNC ||
            role === FINANCE
              ? ""
              : ss_id,
          status,
          userId: userId
            ? userId
            : role === ADMIN ||
              role === ADMIN_USER ||
              role === OPERATIONS ||
              role === SUPPORT ||
              role === RNC ||
              role === FINANCE
            ? ""
            : userId
        },
        headers: {},
        url: API_ENDPOINT.core_url + "reseller/fetch/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeClientStatus: ({ status, userId }) => {
    const id = secureStorage.getItem(SS_USER_HASH_ID);

    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          userRefId: id,
          status,
          userId
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/status/change"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateReseller: ({
    firstName,
    lastName,
    email,
    mobileNumber,
    status,
    userId,
    bankAccountNumber,
    bankIfscCode,
    nameAsPerBank
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          email,
          mobileNumber,
          status,
          userId,
          bankAccountNumber,
          bankIfscCode,
          nameAsPerBank
        },
        headers: {},
        url: API_ENDPOINT.core_url + "reseller/update"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateRate: ({ clientId, service, ipWhitelist }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          clientId,
          service,
          ipWhitelist
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/update/service/rate"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateRolemanagement: ({
    firstName,
    lastName,
    email,
    mobileNumber,
    role,
    userId,
    aclList
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          email,
          mobileNumber,
          role,
          userId,
          aclList
        },
        headers: {},
        url: API_ENDPOINT.core_url + "admin/edit"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateAclmanagement: ({ userId, aclList }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          userId,
          aclList
        },
        headers: {},
        url: API_ENDPOINT.core_url + "admin/editAcl"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchTransactionList: ({
    page = 0,
    size = 10,
    dateRange = "",
    clientId = "",
    resellerId = "",
    status = "",
    serviceType = "",
    rootReferenceId = "",
    transactionId = "",
    custRefNo = "",
    serviceProviderName = "",
    van = "",
    mechanism = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          clientId: clientId !== "" ? clientId : role === CLIENT ? ss_id : "",
          status,
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : "",
          serviceType,
          transactionId,
          custRefNo,
          serviceProviderName,
          van,
          mechanism
        },
        headers: {},
        url: API_ENDPOINT.core_url + "transaction/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchSettlementList: ({
    page = 0,
    size = 10,
    dateRange = "",
    userId = "",
    userRefId = "",
    status = "",
    serviceType = "",
    rootReferenceId = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          userId: userId !== "" ? userId : role === CLIENT ? ss_id : "",
          status,
          userRefId:
            userRefId !== "" ? userRefId : role === RESELLER ? ss_id : "",
          serviceType,
          rootReferenceId:
            rootReferenceId !== ""
              ? rootReferenceId
              : role === SALES
              ? ss_id
              : ""
        },
        headers: {},
        url: API_ENDPOINT.core_url + "finance/settlement/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchRevenueList: ({
    page = 0,
    size = 10,
    dateRange = "",
    userId = "",
    userRefId = "",
    status = "",
    serviceType = ""
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      const role = secureStorage.getItem(SS_ROLE);
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          userId:
            userId !== ""
              ? userId
              : role?.toUpperCase() === ADMIN ||
                role?.toUpperCase() === ADMIN_USER ||
                role?.toUpperCase() === RESELLER ||
                role?.toUpperCase() === FINANCE ||
                role?.toUpperCase() === RNC ||
                role?.toUpperCase() === SUPPORT ||
                role?.toUpperCase() === OPERATIONS ||
                role?.toUpperCase() === SALES
              ? ""
              : ss_id,
          status,
          userRefId:
            userRefId !== ""
              ? userRefId
              : role?.toUpperCase() === RESELLER
              ? ss_id
              : role?.toUpperCase() === ADMIN ||
                role?.toUpperCase() === ADMIN_USER ||
                role?.toUpperCase() === FINANCE ||
                role?.toUpperCase() === RNC ||
                role?.toUpperCase() === SUPPORT ||
                role?.toUpperCase() === OPERATIONS ||
                role?.toUpperCase() === SALES
              ? ""
              : ss_id,
          serviceType,
          rootReferenceId: role === SALES ? ss_id : ""
        },
        headers: {},
        url: API_ENDPOINT.core_url + "finance/revenue/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createUser: ({
    firstName,
    lastName,
    email,
    mobileNumber,
    role,
    aclList,
    internal
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          email,
          mobileNumber,
          role,
          aclList,
          internal
        },
        headers: {},
        url: API_ENDPOINT.core_url + "admin/create"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  editClientUser: ({
    firstName = "",
    lastName = "",
    mobileNumber = "",
    email = "",
    accountNumber = "",
    ifscCode = "",
    accountHolderName = "",
    userId = "",
    userRefId = "",
    remitterAccountName = "",
    remitterAccountNumber = "",
    remitterAccountIfsc = "",
    corpId = "",
    securityAmount = "",
    securityStatus = "",
    reservePercentage = "",
    reserveAmount = "",
    reserveStatus = "",
    dateOfBirth = "",
    panNumber = "",
    gstNumber = "",
    businessType = "",
    websiteLink = "",
    businessName = "",
    businessAddress = "",
    nameAsPerBank = "",
    isKycVerified = "",
    industryType = "",
    dinNumber = "",
    dpan = "",
    legalName = ""
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          mobileNumber,
          email,
          accountNumber,
          ifscCode,
          accountHolderName,
          userId,
          userRefId,
          remitterAccountName,
          corpId,
          remitterAccountNumber,
          remitterAccountIfsc,
          securityAmount,
          securityStatus,
          reservePercentage,
          reserveAmount,
          reserveStatus,
          reserveAmount,
          dateOfBirth,
          panNumber,
          gstNumber,
          businessType,
          websiteLink,
          businessName,
          businessAddress,
          nameAsPerBank,
          isKycVerified,
          industryType,
          dinNumber,
          dpan,
          legalName
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/edit"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  cashFreeDirectTransfer: ({ data, clientId, programId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { ...data },
        headers: { client_secret: clientId, program_id: programId },
        url: API_ENDPOINT.base_url + "cf-svc/api/v1/external/direct-transfer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  equitasDirectTransfer: ({ data, clientId, programId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { ...data },
        headers: { client_secret: clientId, program_id: programId },
        url: API_ENDPOINT.base_url + "eq-svc/api/v1/external/direct-transfer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  eskayDirectTransfer: ({ data, clientId, programId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { ...data },
        headers: { client_secret: clientId, program_id: programId },
        url: API_ENDPOINT.base_url + "eskay-svc/api/v1/external/direct-transfer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateAdminStatus: ({ status, userId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { status, userId },
        headers: {},
        url: API_ENDPOINT.core_url + "admin/edit/status"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  cashFreeBulkTransfer: ({ formData, clientId, programId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapperWithFormData({
        body: { formData },
        headers: { client_secret: clientId, program_id: programId },
        url:
          API_ENDPOINT.base_url + "cf-svc/api/v1/external/bulk/direct-transfer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  checkPennyDropAccount: ({ ifsc, accNo, benificiaryName, address }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        url: API_ENDPOINT.core_url + "pennyDrop/check/account",
        headers: {},
        body: {
          ifsc,
          accNo,
          benificiaryName,
          address
        }
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchClientReserves: () => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

      ApiPostServiceWrapper({
        body: {
          userId: ss_id
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/fetch/reserves/balance"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatedClientCid: ({
    clientId = "",
    vba = "",
    cid = "",
    sid = "",
    serviceProviderName = "",
    merchantId = "",
    authKey = "",
    mcc = ""
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          clientId,
          vba,
          cid,
          sid,
          serviceProviderName,
          merchantId,
          authKey,
          mcc
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/update/service/cid"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addComments: ({
    content,
    senderId,
    senderDetails,
    roomId,
    user,
    roomName
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          content,
          senderId,
          senderDetails,
          roomId,
          user,
          roomName
        },
        headers: {},
        url: API_ENDPOINT.core_url + "comment/create"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addFundsEquitas: ({
    clientId,
    programId,
    amount,
    remarks,
    serviceProviderName
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          amount,
          remarks
        },
        headers: {
          client_secret: clientId,
          program_id: programId,
          serviceProviderName
        },
        url: API_ENDPOINT.core_url + "client/payout/add/funds"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addFundsZyro: ({ clientId, programId, amount, remarks }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          amount,
          remarks
        },
        headers: {
          client_secret: clientId,
          program_id: programId
        },
        url: API_ENDPOINT.core_url + "client/equitas/add/funds"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  approveRejectPrefundAction: ({ action, transferUniqueNo, clientId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          action,
          clientId,
          transferUniqueNo
        },
        url: API_ENDPOINT.core_url + "prefund/request/action"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTransactionLimit: ({ clientId, programs }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          clientId,
          programs
        },
        url: API_ENDPOINT.core_url + "client/update/program/client"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateAddservice: ({ serviceData, clientId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { ...serviceData, clientId },
        url: API_ENDPOINT.core_url + "client/update/addservice"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getPayinClientList: ({ serviceType, serviceProviderName }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          serviceType: serviceType,
          serviceProviderName: serviceProviderName
        },
        url: API_ENDPOINT.core_url + "client/fetch/payin/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  singleEntryCustomer: ({ customerName, email, mobileNumber, upi, type }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          customerName,
          email,
          mobileNumber,
          upi,
          type
        },
        headers: {},
        url: API_ENDPOINT.base_url + "risk-svc/api/v1/customer/single/entry"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateCustomerStatus: ({ customerId, status }) => {
    return new Promise((resolve, reject) => {
      ApiPutServiceWrapper({
        body: {
          customerId,
          status
        },
        headers: {},
        url: API_ENDPOINT.base_url + "risk-svc/api/v1/customer/update/status"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchCustomerList: ({
    page = 0,
    size = 10,
    status,
    email,
    mobileNumber,
    upi
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          email,
          mobileNumber,
          status,
          upi
        },
        headers: {},
        url: API_ENDPOINT.base_url + "risk-svc/api/v1/customer/fetch/list"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCustomer: ({
    customerName,
    email,
    mobileNumber,
    upi,
    type,
    customerId
  }) => {
    return new Promise((resolve, reject) => {
      ApiPutServiceWrapper({
        body: {
          customerName,
          email,
          mobileNumber,
          upi,
          type,
          customerId
        },
        headers: {},
        url: API_ENDPOINT.base_url + "risk-svc/api/v1/customer/edit"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getVanCustomerList: ({
    page,
    size = 10,
    dateRange = "",
    customerHashId = "",
    clientHashId = "",
    status,
    van = "",
    name = "",
    createdby = "",
    resellerId = "",
    serviceProviderName = "",
    email = "",
    mobileNumber = ""
  }) => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          page,
          size,
          dateRange,
          customerHashId,
          clientHashId:
            clientHashId !== "" ? clientHashId : role === CLIENT ? ss_id : "",
          status,
          van,
          name,
          status,
          createdby: role === SALES ? ss_id : "",
          resellerId:
            resellerId !== "" ? resellerId : role === RESELLER ? ss_id : "",
          serviceProviderName,
          email,
          mobileNumber
        },
        headers: {},
        url: API_ENDPOINT.core_url + "client/customer/list"
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  upiCollectRequest: ({
    upiId,
    customerName,
    amount,
    customerMobileNo,
    remark = "",
    programId
  }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      ApiPostServiceWrapper({
        body: { upiId, customerName, amount, customerMobileNo, remark },
        url: API_ENDPOINT.core_url + "client/upi/transfer",
        headers: {
          client_secret: ss_id,
          program_id: programId
        }
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  upiQrGeneration: ({ amount, remark = "", programId }) => {
    return new Promise((resolve, reject) => {
      const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
      ApiPostServiceWrapper({
        body: { amount, remark },
        url: API_ENDPOINT.core_url + "client/qr/generate",
        headers: {
          client_secret: ss_id,
          program_id: programId
        }
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addPrograms: ({
    clientId,
    comissionRate,
    mechanism,
    comissionType,
    vpaSubstring,
    mcc,
    notifyUrl
  }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          clientId,
          comissionRate,
          mechanism,
          comissionType,
          vpaSubstring,
          mcc,
          notifyUrl
        },
        url: API_ENDPOINT.core_url + "client/add/programs"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  SettlementUploadFile: ({ file }) => {
    console.log(file, "File is coming");
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { file },
        url: API_ENDPOINT.core_url + "finance/upload/settlement/details"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeSettlementStatus: ({ action, settlementId }) => {
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: { action, settlementId },
        headers: {},
        url: API_ENDPOINT.core_url + "finance/settlement/status/change"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createVanCustomer: ({
    firstName,
    lastName,
    mobileNumber,
    pan,
    email,
    middleName,
    token
  }) => {
    //const token = secureStorage.getItem(SS_AUTH_TOKEN);
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          mobileNumber,
          panNo: pan,
          email,
          middleName,
          bankDetails: [
            {
              remitterAccountNumber: "1234567890123456",
              ifscCode: "ABCD0123456"
            }
          ]
        },
        headers: {
          "client-hash-id": ss_id,
          Authorization: "Bearer " + token
        },
        // url: "http://localhost:5030/eqv-svc/api/v1/exposed/client/customer"
        url: API_ENDPOINT.equitas_van_url + "/exposed/client/customer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  generateAuthenticatedTokenForVan: ({ programId }) => {
    console.log(programId, "9999");
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          userId: ss_id,
          programId
        },
        headers: {},
        // url: "http://localhost:5030/eqv-svc/api/v1/exposed/client/customer"
        url: API_ENDPOINT.equitas_van_url + "/exposed/authenticate"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createVpaCustomer: ({
    firstName,
    lastName,
    mobileNumber,
    pan,
    email,
    middleName,
    upiProgramId
  }) => {
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          firstName,
          lastName,
          mobileNumber,
          panNo: pan,
          email,
          middleName,
          remitterAcc: [
            {
              remitterAccIfsc: "ABCD0123456",
              remitterAccNumber: "1234567890123456"
            }
          ]
        },
        headers: {
          client_secret: ss_id,
          program_id: upiProgramId
          //Authorization: "Bearer " + token
        },
        //url: "http://localhost:5033/eq-upi/api/v1/external/customer"
        url: API_ENDPOINT.equitas_upi_url + "/external/customer"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  qrGenerateEqUpi: ({ customerVPA, amount, upiProgramId }) => {
    console.log(customerVPA, amount, upiProgramId);
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiPostServiceWrapper({
        body: {
          amount,
          customerVPA
        },
        headers: {
          client_secret: ss_id,
          program_id: upiProgramId
          //Authorization: "Bearer " + token
        },
        //url: "http://localhost:5033/eq-upi/api/v1/external/generate/intent-url"
        url: API_ENDPOINT.equitas_upi_url + "/external/generate/intent-url"
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
